<script>
    import { Router, Link, Route, navigate, useLocation } from "svelte-routing";
    import { onMount, tick } from "svelte";
    import InserirUsuario from "./Telas/InsercaoDados/TelaInsereDadosUsuario.svelte";
    import TelaDeCampeonatos from "./Telas/Campeonatos/TelaDeCampeonatos.svelte";

    import TelaMenuConfig from "./Telas/Menu/TelaMenuConfig.svelte";
    import Login from "./Telas/Autenticacao/TelaLogin.svelte";
    
    //import Home from "./SiteNutri/HomeOnline.svelte";
    import Home from "./SiteNutri/Home.svelte"; 
    import ListaHorarios from "./SiteNutri/ListaHorarios.svelte";
    import CriarHorario from "./SiteNutri/Agendar.svelte";
    import Conexoes from "./Classes/Conexoes";  
    import Constantes from "./Classes/Constantes";  
import ProtectedRoute from "./ProtectedRoute.svelte";
 import SplashScreen from "./SiteNutri/SplashScreen.svelte";
 import MapaCalendario from "./SiteNutri/MapaCalendario.svelte";
 import Tarefas from "./SiteNutri/tarefas.svelte";
 import Dinheiro from "./SiteNutri/tarefas_dinheiro.svelte";
 import Gastos from "./SiteNutri/RelatorioGastos.svelte";
 import QrCode from "./SiteNutri/GeraQRCode.svelte";
 import Metas from "./SiteNutri/ControleMetas.svelte";
 import NEE from "./NEE2.svelte";
    import { logado, atualizarLogado } from "./Classes/EstadoLogado";
    import {
        permissaoUsuario,
        permissaoPlataforma,
        DadosGenericos,
        DadosPaginaAnterior,
        DadosLogin,
    } from "./Classes/Stores";

  
    function PegaParametro(e) {
        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get(e);
        return id;
    }
    let carregandoPromise;
    let clicked = false;
    let showSidebar = true; // Variável reativa para mostrar/ocultar o menu lateral

    let pagAnterior = ""; // Defina a página inicial

    let token;
    let usuario;
    let id_empresa;
    let parametros = {};
    let api = "acesso.php";
    let conexoes = new Conexoes(Constantes.url_base_nutri);
    /*  let interval = setInterval(
        async () => {
           // //console.log("url ", url);
           // //console.log("logado ", Constantes.logado);
        },

        1000,
    );*/
    let carregando = true;
    function getPageFromURL() {
        const { pathname } = window.location;
        const currentPage = pathname.substring(1); // Remove a barra inicial "/"
        return currentPage;
    }

    let actualPage = getPageFromURL();

    function ChecaPaginaAnterior() {
        /*const pag = getPageFromURL();
        if (pag.includes("prepagamento")) {
            pagAnterior = "/inscricao";
        } else if (pag.includes("preinscricao")) {
            pagAnterior = "/campeonatos";
        } else if (pag.includes("inscricao")) {
            pagAnterior = "/preinscricao";
        } else {
            pagAnterior = "";
        }*/
    }

    async function VerificaLogado() {
        carregando = true;
        token = localStorage.getItem("token");
        id_empresa = localStorage.getItem("id_empresa");
        usuario = localStorage.getItem("usuario");
        //console.log("logando");
        if (!token || !usuario || !id_empresa) {
            Constantes.logado = false;
            //console.log("nao logou");
            localStorage.setItem("token", "");
            localStorage.setItem("usuario", "");
            localStorage.setItem("id_empresa", "");
            carregando = false;
            //navigate("/login");
            atualizarLogado(false);
            return;
        }

        parametros["token"] = token;
        parametros["query_code"] = "acesso_token";
        parametros["usuario"] = usuario;
        parametros["id_empresa"] = id_empresa;
        const retorno = await conexoes.conecta(api, parametros);
        //console.log("nao logou2");
        if (retorno.sucesso) {
           localStorage.setItem("token", retorno.token);

          
            permissaoUsuario.set(retorno);
            permissaoPlataforma.set(retorno);
            DadosLogin.set(retorno);

            atualizarLogado(true);
            Constantes.logado = true;
            //console.log("armazenou");
        } else {
            localStorage.setItem("token", "");
            localStorage.setItem("usuario", "");
            localStorage.setItem("id_empresa", "");
            Constantes.logado = false;
            //console.log("armazenou2");
            atualizarLogado(false);
            // navigate("/");
        }
        carregando = false;
    }

    function updateSidebarVisibility() {
        showSidebar = window.matchMedia("(min-width: 769px)").matches;
    }

    onMount(async () => {
        carregandoPromise = await VerificaLogado();
        const interval = setInterval(() => {
            ChecaPaginaAnterior();
        }, 1000);

        window.addEventListener("resize", updateSidebarVisibility);
        updateSidebarVisibility(); // Inicializa a visibilidade da barra lateral

        return () => {
            clearInterval(interval);
            window.removeEventListener("resize", updateSidebarVisibility);
        };
    });

    function irParaPagina(pagina) {
        paginaAtual = pagina;
    }

    export let url = "";
</script>


   <!--<Router {url} basepath="/online">--> 

   <Router {url} >
        <div class="layout">
           
          
            <div class="content">
                <Route path="/" component={Home} />
                <Route path="/home" component={Home} />


                <!--
                <Route path="/tarefas" component={Tarefas} />
               
               -->
                <Route path={"/CriarHorarios"}>
                    <ProtectedRoute
                        component={CriarHorario}
                        params={PegaParametro("id")}
                    />
                </Route>
                <Route path={"/Gastos"}>
                    <ProtectedRoute
                        component={Gastos}
                        params={PegaParametro("id")}
                    />
                </Route>
                <Route path={"/GASTOS"}>
                    <ProtectedRoute
                        component={Gastos}
                        params={PegaParametro("id")}
                    />
                </Route>
                <Route path={"/gastos"}>
                    <ProtectedRoute
                        component={Gastos}
                        params={PegaParametro("id")}
                    />
                </Route>
                <Route path={"/tarefas"}>
                    <ProtectedRoute
                        component={Tarefas}
                        params={PegaParametro("id")}
                    />
                    
                </Route>
                   <Route path={"/metas"}>
                    <ProtectedRoute
                        component={Metas}
                        params={PegaParametro("id")}
                    />
                    
                </Route>
                   <Route path={"/dinheiro"}>
                    <ProtectedRoute
                        component={Dinheiro}
                        params={PegaParametro("id")}
                    />
                    
                </Route>
               
                   <Route path={"/qrcode"}>
                    <ProtectedRoute
                        component={QrCode}
                        params={PegaParametro("id")}
                    />
                    
                </Route>
                <Route path={"/criar"}>
                    <ProtectedRoute
                        component={CriarHorario}
                        params={PegaParametro("id")}
                    />
                </Route>
                <Route path={"/nee"}>
                    <ProtectedRoute
                        component={NEE}
                        params={PegaParametro("id")}
                    />
                </Route>
                 <Route path={"/mapa"}>
                    <ProtectedRoute
                        component={MapaCalendario}
                        params={PegaParametro("id")}
                    />
                </Route>
               
                <Route path={"/Apagar"}>
                    <ProtectedRoute
                        component={ListaHorarios}
                        params={PegaParametro("id")}
                    />
                </Route>
                  <Route path={"/pagar"}>
                    <ProtectedRoute
                        component={ListaHorarios}
                        params={PegaParametro("id")}
                    />
                </Route>

            </div>
        </div>
    </Router>


<style>
    .layout {
        display: flex;
        flex-direction: row;
    }

    .content {
        flex-grow: 1;
    }
</style>
